import React, { Fragment, useState } from "react"
import { Helmet } from "react-helmet"
import { Link } from "react-router-dom"

import ThemeMenuThree from "../../../components/header/ThemeMenuThree"
import PageTitle from "../../../components/page-title/PageTitle"
import FeatureThree from "../../../components/feature/FeatureThree"
import BlockStyleOneA from "../../../components/block/BlockStyleOneA"
import CounterTwoA from "../../../components/counter/CounterTwoA"
import TeamTwo from "../../../components/team/TeamTwo"
import PricingTab from "../../../components/price/PricingTab"
import NewsletterOne from "../../../components/call-to-action/NewsletterOne"
import FooterThree from "../../../components/footer/FooterThree"
import ModalVideos from "../../../components/modal-video/ModalVideos"


const About = () => {
    const [open, setOpen] = useState(false);
    const OpenModal = () => {
        setOpen(!open)
    }

    return (
        <Fragment>
            <ModalVideos isOpen={open} onClick={OpenModal} />
            <div className="main-page-wrapper">
                {/* Helmet start */}
                <Helmet>
                    <title>Sobre Nosotros – Innovación Tecnológica y Educación</title>
                    <meta name="description" content="Conoce a CuySoft: empresa ecuatoriana dedicada a la innovación tecnológica y educación digital. Nuestro equipo experto impulsa la transformación digital en Ecuador." />
                    <meta name="keywords" content="sobre CuySoft, equipo tecnológico Ecuador, innovación tecnológica, educación digital, transformación digital Ecuador" />
                    <link rel="canonical" href="https://www.cuysoft.com/about" />
                    <meta property="og:title" content="Sobre CuySoft – Innovación Tecnológica en Ecuador" />
                    <meta property="og:description" content="Conoce nuestro equipo experto dedicado a la innovación tecnológica y educación digital en Ecuador." />
                    <meta property="og:url" content="https://www.cuysoft.com/about" />
                </Helmet>
                {/* Helmet end */}

                {/* ThemeMenuThree */}
                <ThemeMenuThree />
                {/* ThemeMenuThree */}

                {/* PageTitle */}
                <PageTitle title="Sobre Nosotros" />
                {/* PageTitle */}


                {/*cuysoft-feature start*/}
                <section className="cuysoft-feature pt-150 pt-lg-100 pb-30 pb-lg-15">
                    <div className="container">
                        <FeatureThree />
                    </div>
                </section>
                {/*cuysoft-feature end*/}

                {/*about-cuysoft start*/}
                <section className="about-cuysoft about-cuysoft-4d pt-140 pb-75 pt-lg-60 pb-lg-15">
                    <img className="about-shape-4d shape-1b d-none d-xl-inline-block" src="assets/img/shape/star-3b.svg" alt="shape" />
                    <img className="about-shape-4d shape-2b d-none d-lg-inline-block" src="assets/img/shape/star-4b.svg" alt="shape" />
                    <img className="about-shape-4d shape-3b d-none d-md-inline-block" src="assets/img/shape/star-4b.svg" alt="shape" />
                    <img className="about-shape-4d shape-4b d-none d-md-inline-block" src="assets/img/shape/star-7c.svg" alt="shape" />
                    <img className="about-shape-4d shape-5b d-none d-xl-inline-block" src="assets/img/shape/star-4b.svg" alt="shape" />
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5 align-items-center">
                            <div className="col-lg-7" data-aos="fade-right" data-aos-delay={100}>
                                <div className="about-img-wrapper-four position-relative mb-45">
                                    <img className="main-img" src="assets/img/about/about-3d.jpg" alt="Oficina de CuySoft equipo de innovación tecnológica" />
                                    <img className="main-img-two d-none d-xl-inline-block" src="assets/img/about/about-4d.jpg" alt="Equipo CuySoft trabajando en proyectos de educación digital" />
                                    <img className="shape-one" src="assets/img/shape/line-round-2a.svg" alt="shape" />
                                </div>
                            </div>
                            <div className="col-lg-5" data-aos="fade-left" data-aos-delay={100}>
                                <BlockStyleOneA />
                            </div>
                        </div>
                    </div>
                </section>
                {/*about-cuysoft end*/}


                {/*counter-area end*/}
                <section className="counter-area pt-70 pb-100 pt-lg-25 pb-lg-15">
                    <div className="container">
                        <CounterTwoA />
                    </div>
                </section>
                {/*counter-area start*/}


                {/*cuysoft-team start*/}
                <section className="gradient-bg cuysoft-team team-sec-two mt-0 pt-95  pb-90 pt-lg-55 pb-lg-60">
                    <img className="team-shape shape-1b" src="assets/img/shape/star-3b.svg" alt="shape" />
                    <img className="team-shape shape-2b" src="assets/img/shape/star-4b.svg" alt="shape" />
                    <img className="team-shape shape-3b" src="assets/img/shape/star-6b.svg" alt="shape" />
                    <img className="team-shape shape-4b" src="assets/img/shape/star-5b.svg" alt="shape" />
                    <img className="team-shape shape-5b" src="assets/img/shape/star-5b.svg" alt="shape" />
                    <img className="team-shape shape-6b" src="assets/img/shape/line-round-6b.svg" alt="shape" />
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5">
                            <div className="col-lg-12">
                                <div className="section-title-two text-center mb-55">
                                    <h6 className="sub-title mb-20">Nuestro Equipo</h6>
                                    <h2 className="sect-title">Miembros Expertos del Equipo</h2>
                                </div>
                            </div>
                        </div>
                        <TeamTwo />
                        <div className="row gx-4 gx-xxl-5">
                            <div className="col-lg-12 text-center pt-15" data-aos="fade-up" data-aos-delay={200}>
                                <Link className="theme_btn" to="/team">Ver Todo el Equipo</Link>
                            </div>
                        </div>
                    </div>
                </section>
                {/*cuysoft-team end*/}

                {/*cuysoft-video start*/}
                <section className="cuysoft-video pt-230 pb-230 pt-lg-150 pb-lg-150">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-12">
                                <div className="video-wrapper-two text-center">
                                    <a className="popup-video mb-30" onClick={OpenModal} ><i className="bi bi-play-fill" /></a>
                                    <h4>Ver Videos</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/*cuysoft-video end*/}

                {/*teachy-price start*/}
                <section className="cuysoft-price price-bg pt-150 pb-50 pt-lg-60">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5">
                            <div className="col-lg-12">
                                <div className="section-title-two text-center mb-30 pb-1">
                                    <h6 className="sub-title mb-20">Lista de Precios</h6>
                                    <h2 className="sect-title">Nuestros Precios Simples y Fáciles</h2>
                                </div>
                            </div>
                        </div>
                        <PricingTab />
                    </div>
                </section>
                {/*teachy-price end*/}

                {/*cuysoft-newsletter start*/}
                <NewsletterOne />
                {/*cuysoft-newsletter end*/}

                {/*FooterThree start*/}
                <FooterThree />
                {/*FooterThree end*/}

            </div>

        </Fragment>
    )
}

export default About